/* Contact questionnaire. Real submission handled by Shopify's native contact form. */
(() => {
  'use strict';
  function configure(dialog, detail = {}) {
    const form = dialog.querySelector('form');
    if (!form) return;
    form.reset();
    const vehicle = form.querySelector('[data-contact-vehicle]');
    const hint = form.querySelector('[data-contact-vehicle-hint]');
    const status = form.querySelector('[data-contact-status]');
    const text = String(detail.vehicle || '').slice(0, 120);
    if (vehicle) vehicle.value = text;
    if (hint) hint.hidden = !text;
    const productReference = form.querySelector('[data-contact-product]');
    if (productReference) productReference.value = String(detail.product || '').slice(0, 180);
    if (status) { status.hidden = true; status.textContent = ''; }
    const topic = String(detail.topic || '');
    const matched = [...form.querySelectorAll('[data-contact-topic]')].find((item) => item.value === topic);
    if (matched) matched.checked = true;
  }
  document.addEventListener('leonparc:configure-contact', (event) => {
    if (event.target instanceof HTMLDialogElement) configure(event.target, event.detail);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-demo-contact]')) return;
    event.preventDefault();
    const status = form.querySelector('[data-contact-status]');
    if (status) {
      status.textContent = 'Dit is een demo: het formulier is ingevuld, maar er is niets verzonden.';
      status.hidden = false;
      status.focus({ preventScroll: false });
    }
  });
  const handleResult = () => {
    const dialog = document.querySelector('dialog[data-contact-dialog]');
    if (!dialog || !dialog.querySelector('[data-contact-success], [data-contact-errors]')) return;
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    dialog.querySelector('[data-contact-success], [data-contact-errors]')?.focus({ preventScroll: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleResult, { once: true });
  else handleResult();
})();
